import * as Yup from 'yup';

export const SCRIPT_MAX_LENGTH = 1000;

export const SpotlightSchema = (t: Function) =>
  Yup.object().shape({
    text: Yup.string()
      .max(
        SCRIPT_MAX_LENGTH,
        `Script cannot exceed ${SCRIPT_MAX_LENGTH} characters.`
      )
      .test(
        'not-just-spaces',
        t('Please enter a valid value'),
        value => !value || value.trim().length > 0
      )
      .required(t('Script text is required.')),
  });
